module.exports = __webpack_public_path__ + "assets/b6.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b6.png
// module id = 649
// module chunks = 0